import BaseModal from 'components/Modals/BaseModal';
import DeviceSettings from 'features/Integrations/features/ConnectedDevices/features/DeviceSettings/index.web';
import { Button } from 'react-bootstrap';
import { BsChevronLeft } from 'react-icons/bs';
import type { GenericDeviceModalProps } from './GenericDeviceModal.types';

const GenericDeviceModal = ({
  device,
  group,
  stageOpen,
  usgsOpen,
  onClearDeviceSettings,
  onSelectFromGroup,
}: GenericDeviceModalProps) => {
  return (
    <>
      <BaseModal
        show={!!device && !stageOpen && !usgsOpen}
        handleShow={onClearDeviceSettings}
        title={device?.alias}
        size="xl"
        contentStyle={{
          minHeight: 'min(75dvh, calc(100dvh - 12rem))',
          maxHeight: 'calc(100dvh - 8rem)',
          overflowY: 'auto',
          overflowX: 'hidden',
        }}
        bodyClassName="customScrollbar-Y min-h-0"
      >
        {group && (
          <Button variant="link" className="px-0" onClick={onClearDeviceSettings}>
            <BsChevronLeft /> Back
          </Button>
        )}

        {device && <DeviceSettings key={device.id} device={device} />}
      </BaseModal>
    </>
  );
};

export default GenericDeviceModal;
